// Som da arena fora da batalha: usa o MESMO motor e os mesmos ajustes de volume do jogo
// (/gb/sound.js), que o jogador controla na engrenagem.
let carregando = null;

const carregar = () => {
  if (window.GBSound) return Promise.resolve(window.GBSound);
  if (carregando) return carregando;
  carregando = new Promise((ok) => {
    const s = document.createElement('script');
    s.src = '/gb/sound.js?v=18';
    s.async = true;
    s.onload = () => ok(window.GBSound || null);
    s.onerror = () => ok(null);
    document.head.appendChild(s);
  });
  return carregando;
};

export const gbSfx = (nome) => {
  carregar().then((S) => {
    if (!S) return;
    try { S.unlock(); S.sfx[nome]?.(); } catch (e) { /* noop */ }
  });
};

// trilha da tela: 'inicio' | 'sala' | 'loja' | 'duelo' · null para silenciar
export const gbMusic = (cena) => {
  carregar().then((S) => {
    if (!S) return;
    try { if (cena) S.music.play(cena); else S.music.stop(); } catch (e) { /* noop */ }
  });
};

export const gbAudioCfg = () => carregar().then((S) => (S ? S.cfg() : null));

export const gbAudioSet = (patch) => carregar().then((S) => (S ? S.set(patch) : null));

// baixa TODAS as trilhas e efeitos (pesado: ~17 MB de música). Roda em SEGUNDO PLANO
// depois que a arena já abriu — travar a entrada nisso fazia a conexão ao vivo demorar.
export const gbPreloadAudio = (onProgress) =>
  carregar().then((S) => {
    if (!S || !S.preload) { onProgress?.(100); return null; }
    try { S.unlock(); } catch (e) { /* noop */ }
    return S.preload(onProgress);
  }).catch(() => { onProgress?.(100); });

// só os efeitos (leves): garante que o 1º tiro/avião já saia do arquivo
export const gbWarmSfx = () =>
  carregar().then((S) => {
    if (!S || !S.warm) return null;
    try { S.unlock(); } catch (e) { /* noop */ }
    return S.warm();
  }).catch(() => null);

export default gbSfx;
